{
	"title": "Declarații",
	"table": {
		"material": "Material",
		"dateOfIssue": "Data emiterii",
		"quantity": "Cantitate",
		"carbonSavings": "Reduceri de CO\u2082",
		"status": {
			"title": "Stare",
			"TransactionProcessing": "Procesare tranzacție",
			"CreatingDeclaration": "Se creează declarația",
			"GenerationFailed": "Generarea a eșuat",
			"ReadyToDownload": "Gata de descărcare"
		}
	},
	"declarationLanguageSelect": {
		"title": "Limba declarației",
		"description": "Selectați o limbă pentru declarație.",
		"label": "Limba declarației",
		"buttonBack": "Înapoi",
		"buttonSave": "Salvează"
	},
	"downloadAllLanguageSelect": {
		"title": "Limbile declarațiilor",
		"descriptionGlobal": "Selectați o limbă pentru toate declarațiile.",
		"descriptionIndividual": "Sau setați limba pentru fiecare declarație în mod individual.",
		"label": "Limbile declarațiilor",
		"tableHeaderDeclaration": "Declarație (material/data emiterii)",
		"tableHeaderLanguage": "Limba declarației",
		"buttonBack": "Înapoi",
		"buttonDownload": "Descarcă declarații"
	},
	"declarationActions": {
		"changeLanguage": "Schimbă limba declarației",
		"preview": "Previzualizare",
		"download": "Descarcă",
		"transaction": "Tranzacție",
		"showMoreTransactions": "Afișează mai multe tranzacții",
		"languageLabel": "Limba declarației",
		"downloadAll": "Descarcă toate declarațiile"
	}
}
